import { action } from 'satcheljs';
import {
    HealthDelegateEvent,
    HealthDelegateActor,
    HealthDelegateDataLoad,
} from '@outlook/hxcore_web';

export const hxObjectLoaded = action(
    '__DIAGNOSTICS_HX_HEALTH_EVENT',
    (healthData: HealthDelegateDataLoad) => ({
        healthData,
    })
);

export const hxActorCompleted = action(
    '__DIAGNOSTICS_HX_ACTOR_COMPLETION',
    (healthData: HealthDelegateActor) => ({
        healthData,
    })
);

export const hxChangeNotification = action(
    '__DIAGNOSTICS_HX_CHANGE_NOTIFICATION',
    (healthData: HealthDelegateEvent) => ({
        healthData,
    })
);
